<template>
    <div class="d-flex flex-column my-3">
        <a
            :href="item.url"
            target="_blank"
            class="d-flex justify-content-between cursor-pointer text-decoration-none"
            :data-dd-action-name="`TemplateRelation newtab to ${type}`"
        >
            <div class="d-flex">
                <div>
                    <img
                        v-if="type === 'product'"
                        :src="item.src || require('../../../assets/home/icons/icon-placeholder.png')"
                        :alt="item.title"
                        class="item-img"
                    />
                    <div v-else class="item-img-option-set text-black">OS</div>
                </div>
                <div class="align-self-center d-grid">
                    <h4 class="h6 mx-3 mb-0 font-weight-normal text-truncate text-black">{{ item.title }}</h4>
                </div>
                <div class="align-self-center">
                    <p v-if="item.published" class="mb-0 px-1 font-weight-normal" :class="`color-${status}`">
                        {{ status }}
                    </p>
                </div>
            </div>
            <div class="d-flex">
                <div class="align-self-center">
                    <img
                        :src="require('../../../assets/home/icons/icon-open-new-tab.svg')"
                        alt=""
                        class="icon-open-new-tab"
                    />
                </div>
            </div>
        </a>
        <template v-if="item.childrens">
            <a
                v-for="(child, index) in item.childrens"
                :key="`child-item-${index}`"
                :href="child.url"
                target="_blank"
                class="d-flex py-1 cursor-pointer text-decoration-none"
                :data-dd-action-name="`TemplateRelation newtab to ${child.type}`"
            >
                <div class="d-flex">
                    <div>
                        <div class="item-separator" />
                    </div>
                    <div class="align-self-center d-grid mx-3">
                        <img :src="require('../../../assets/home/icons/icon-tree.svg')" alt="" class="icon-tree mr-2" />
                        <p class="h7 mt-2 mb-0 font-weight-normal text-truncate text-black">
                            <b-badge class="bg-transparent font-weight-normal border-1 type-chip">{{
                                getBadgeType(child.type)
                            }}</b-badge>
                            {{ child.title }}
                        </p>
                    </div>
                </div>
                <div class="d-flex pl-2">
                    <div class="align-self-center">
                        <img
                            v-if="child.type != 'variant'"
                            :src="require('../../../assets/home/icons/icon-open-new-tab.svg')"
                            alt=""
                            class="icon-open-new-tab-xs"
                        />
                    </div>
                </div>
            </a>
        </template>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { ItemType } from './typings';

const props = defineProps<{
    item: ItemType;
    type: string;
}>();

const status = computed(() => {
    const statuses = {
        published: 'Published',
        active: 'Active',
        draft: 'Draft',
        default: ''
    };

    if (!props.item.src || props.item?.published === undefined) {
        return statuses.default;
    }

    if (props.item.src.includes('woo.customily') || props.item.src.includes('etsystatic.com')) {
        return props.item.active === 'true' ? statuses.active : statuses.draft;
    } else {
        return props.item.published === 'true' ? statuses.published : statuses.draft;
    }
});

const getBadgeType = (type: string): string => {
    const types: Record<string, string> = {
        option: 'Option set',
        variant: 'Variant',
        default: ''
    };

    return types[type] || types.default;
};
</script>

<style scoped lang="scss">
.color-Published {
    color: #70ad64;
}

.color-Draft {
    color: #808493;
}

.color-Active {
    color: #4074fb;
}
.icon-chevron-down {
    width: 12px;
    height: 10px;
}

.item-separator {
    width: 50px;
}
.item-img {
    width: 50px;
    height: 50px;
}

.item-img-option-set {
    width: 50px;
    height: auto;
    font-size: 23px;
    font-style: normal;
    font-weight: 700;
}

.icon-open-new-tab {
    width: 21px;
    height: 21px;
}

.icon-open-new-tab-xs {
    width: 16px;
    height: 16px;
}

.icon-tree {
    width: 20px;
}
.d-grid {
    display: grid !important;
    grid-auto-flow: column;
    align-items: center;
}

.text-black {
    color: #000 !important;
}
.type-chip {
    border: solid 1px #d0d1d6;
    color: #333333 !important;
    text-transform: capitalize !important;
}
</style>
